<template>
  <v-card>
    <v-card-text>
      <h3>Blood sugar</h3>
      <convert-box></convert-box>
    </v-card-text>
  </v-card>
</template>

<script>
import ConvertBox from '../components/ConvertBox'

export default {
  components: { ConvertBox },
  data() {
    return {
      unit: [
        {
          text: 'mmol / l',
          val: 1
        },
        {
          text: 'mg / dl',
          val: 18
        },
        {
          text: 'mg%',
          val: 18
        }
      ]
    }
  },
  created() {
    this.$store.dispatch('setUnit', this.unit)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// blood-sugar.vue?1c4a1ed3